module.exports = {
  FLAG_EXTERNAL: 1,
  // FLAG_LIST: 2,
}
